import PropTypes from 'prop-types';
import React from 'react';
import { getStatusUsingWindow } from '.';
import PhaseType from 'types/phase';

export const note = ({ phase = {}, event: { kind = '', data: { task = '', status = '' } = {} } }) =>
  <div className={kind}>
    {task && status && `${task} ${getStatusUsingWindow(phase, status)}`}
  </div>;

note.defaultProps = { phase: {} };

note.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      task: PropTypes.string,
      status: PropTypes.string,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/note.jsx